import {BlueText, SubTitle} from "@FRAMEWORK/ui/desktop/text";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import styled from "styled-components";
import useEventOptionalTourDetail from "@QUERIES/prdt/event/useEventOptionalTourDetail";
import useEventDetail from "@QUERIES/prdt/event/useEventDetail";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";

const ContentTitle = styled(SubTitle)`
	margin: 60px 0 20px;
`;

const TextNone = styled.div`
	display: flex;
	height: 60px;
	border-top: 1px solid var(--line-color);
	border-bottom: 1px solid var(--line-color);
	align-items: center;
	justify-content: center;
`;

const ShoppingComponent = ({evCd}: {evCd: string}) => {
	/** 쇼핑 */
	const useEventOptTourDtl = useEventOptionalTourDetail(evCd);
	const evtOptTourDtl = useEventOptTourDtl.data?.body;
	const shop = evtOptTourDtl?.shopList || [];

	/** 행사 정보 조회 */
	const shopCnt = useEventDetail(evCd).data?.body.shopCnt || 0;

	return (
		<>
			<ContentTitle>쇼핑</ContentTitle>
			{shop.length === 0 && !evtOptTourDtl?.optionalTourInfo.shopInfo && (
				<TextNone>해당 상품은 쇼핑센터 방문이 포함되지 않습니다.</TextNone>
			)}
			{shop.length > 0 && (
				<>
					<p>
						아래 쇼핑 품목 중 총 <BlueText>{shopCnt}번</BlueText>의 쇼핑센터 방문이 일정에 포함되어 있습니다.(쇼핑
						품목은 여행일정에 따라 달라질 수 있습니다.)
					</p>
					<EditorBox margin={"15px 0 0"}>
						<table>
							<caption>개인정보 처리방침 개정 안내</caption>
							<colgroup>
								<col style={{width: "70px"}} />
								<col />
								<col style={{width: "180px"}} />
								<col style={{width: "140px"}} />
								<col style={{width: "180px"}} />
							</colgroup>
							<thead>
								<tr>
									<th scope="col">회차</th>
									<th scope="col">쇼핑 품목</th>
									<th scope="col">쇼핑 장소</th>
									<th scope="col">소요시간</th>
									<th scope="col">환불여부</th>
								</tr>
							</thead>
							<tbody>
								{shop.length > 0 &&
									shop.map((item, index) => {
										const {shopNm, shopPlace, shopTm, refundNote} = item;
										return (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{shopNm}</td>
												<td>{shopPlace}</td>
												<td>{shopTm}</td>
												<td>{refundNote}</td>
											</tr>
										);
									})}
							</tbody>
						</table>
					</EditorBox>
				</>
			)}
			{evtOptTourDtl?.optionalTourInfo.shopInfo && (
				<EditorBox margin={"20px 0"} dangerouslySetInnerHTML={{__html: evtOptTourDtl?.optionalTourInfo.shopInfo}} />
			)}
		</>
	);
};

const Shopping = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="Shopping Error">
		<ShoppingComponent {...props} />
	</ErrorBoundary>
);

export default Shopping;
